import * as L from 'leaflet';
import last from 'lodash/last';
import first from 'lodash/first';
import { Marker } from 'react-leaflet';
import { LabelType } from '../../models/label-type.enum';
import type { ICallDetails } from '../../../../../../../../../models/call-details.model';
import type { IServiceJourneyDetails } from '../../../../../../../../../models/service-journey-details.model';
import LabelHelper from '../../../helpers/label.helper';
import './style.scss';
import { DateTime } from 'luxon';
import { DateTimeHelper } from '../../../../../../../../../helpers/date-time.helper';

function getTimeString(call: ICallDetails, labelType: LabelType): string {
  let time: DateTime | undefined;
  if (labelType === LabelType.departure) {
    time = call.estimatedDepartureTime ? call.estimatedDepartureTime : call.plannedDepartureTime;
  } else {
    time = call.estimatedArrivalTime ? call.estimatedArrivalTime : call.plannedArrivalTime;
  }
  return DateTimeHelper.toTime(time);
}

function TripLegLabelMarker({ serviceJourney, labelType, disabled }: { serviceJourney: IServiceJourneyDetails; labelType: LabelType; disabled: boolean }) {
  const callsOnTripLeg = serviceJourney.callsOnServiceJourney?.filter((c) => c.isOnTripLeg) ?? [];
  const call = labelType === LabelType.departure ? first(callsOnTripLeg) : last(callsOnTripLeg);
  const vericalAnchorPoint = labelType === LabelType.departure ? -3 : 29;
  if (!call || !call.latitude || !call.longitude) {
    return null;
  }

  const isCancelled = labelType === LabelType.arrival ? call.isCancelled && !!call.isArrivalCancelled : call.isCancelled && !!call.isDepartureCancelled;

  const icon = L.divIcon({
    className: `trip-leg-label-marker w-auto h-auto ${disabled ? 'trip-leg-label-marker--disabled' : ''}`,
    html: LabelHelper.createIconHtml(serviceJourney.line.transportMode, getTimeString(call, labelType), serviceJourney.line, isCancelled),
    iconAnchor: [-10, vericalAnchorPoint],
  });

  return <Marker icon={icon} position={[call.latitude, call.longitude]} />;
}

export default TripLegLabelMarker;
